module.exports = __webpack_public_path__ + "static/media/mon-sat_and_everyday_digital.cbeda1cf.webp";